// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zFja","colBig":"styles_colBig__S2AeK","colSmall":"styles_colSmall__1UxoQ"};